/* tslint:disable */
/* eslint-disable */
/**
 * axfoodstorefront API
 * axfoodstorefront Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ImageData
 */
export interface ImageData {
    /**
     * 
     * @type {string}
     * @memberof ImageData
     */
    'altText'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageData
     */
    'format'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageData
     */
    'galleryIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageData
     */
    'imageType'?: ImageDataImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImageData
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageData
     */
    'width'?: number;
}

export const ImageDataImageTypeEnum = {
    Primary: 'PRIMARY',
    Gallery: 'GALLERY'
} as const;

export type ImageDataImageTypeEnum = typeof ImageDataImageTypeEnum[keyof typeof ImageDataImageTypeEnum];


